module.exports = __webpack_public_path__ + "img/8.a94825b3.jpg";